import React from 'react';
import './Banner.css';
import banner from '../assets/Events/Events.png';

const Banner = () => {
  return (
    <div className="banner-container">
      <img
        src={banner}
        alt="Mountain Banner"
        className="banner-image"
      />
    
    </div>
  );
};

export default Banner;
